///////////////////////////////////////////////////////////////////////////////////////////////////
//
// Namespace - Livewire import handler js
// Inline js isn't working because of showing/hiding the importer dynamically
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.import_handler = abcsetup.import_handler || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    Livewire.on('importUploaded', id => {
        $('#import-modal-' + id).modal('show');
    });
});